module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SearchView.js"));
	}, "OrderSearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrderSearchView!./src/pages/Store/Order/Search/SearchView.js
// module id = 2134
// module chunks = 367